import { createFileRoute } from '@tanstack/react-router';

import { MicrosoftSignInPage } from '@/features/auth/pages/MicrosoftSignInPage';

/**
 * `/auth/microsoft` — the URL the Entra My Apps tile opens, and the redirect URI
 * registered on the app registration. Both must stay this exact path.
 *
 * Unauthenticated by design: this is how a person becomes authenticated.
 */
export const Route = createFileRoute('/auth/microsoft')({
  component: MicrosoftSignInPage,
});
